import { isAndroid, isIOS, parseCookie } from '../core/util';

const NET_MAP = {
  wifi: 'wifi',
  weakwifi: 'wifi',
  strongwifi: 'wifi',
  '2g': '2g',
  '3g': '3g',
  '4g': '4g',
  '5g': '5g',
};

function checkJSBridgeReady(JSBNS, callback) {
  callback(window.mqq);
}

export default function (JSBNS, callback) {
  checkJSBridgeReady(JSBNS, (JSBNS) => {
    // eslint-disable-next-line no-unused-vars
    const cookie = parseCookie(document.cookie);
    const params = {
      mac: '',
    };
    if (window.QZAppExternal && window.QZAppExternal.getConn) {
      params.network_type = () => new Promise((resolve) => {
        window.QZAppExternal.getConn((data) => {
          console.log('window.QZAppExternal.getConn:', data);
          const netType = data && data.data && data.data.toLowerCase();
          resolve(NET_MAP[netType] || 'unknown');
        });
      });
    }
    if (isAndroid) {
      Object.assign(params, {
        imei: new Promise((resolve) => {
          JSBNS.invoke('device', 'getDeviceInfo', (res) => {
            resolve((res.data && res.data.identifier) || '');
          });
        }),
        imsi: '',
        android_id: '',
      });
    } else if (isIOS) {
      Object.assign(params, {
        idfa: '',
        idfv: '',
      });
    }
    callback(params);
  });
}
